import routerOptions0 from "/usr/src/app/content/n3-redirections-legacy-52cbd0d3-8d1c-4e8f-abd2-014a4c6da0ba/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}